import type { FeatureFlag } from 'constants/feature-flag';

export const featureFlagsCH: Record<FeatureFlag, boolean> = {
  addressValidation: false,
  availabilityBarf: false,
  calorieCalculator: false,
  cartCrossSellPopUp: false,
  cookieBot: false,
  crossSellCheckout: false,
  crossSellPdp: false,
  dynamicUxTest: false,
  ecoOption: false,
  expressCheckout: false,
  fube: false,
  klarna: true,
  localeSwitcher: false,
  loyaltyProgram: true,
  magazin: false,
  nutritionPlan: false,
  onDemandDelivery: false,
  otp: false,
  pdexEndpoints: true,
  petProfile: false,
  preventionNeed: false,
  reauth: false,
  savingsPlan: false,
  segmentation: true,
  subCrossSell: true,
};
